'use client';

import { useReportWebVitals } from 'next/web-vitals';
import { reportWebVital } from '@/app/lib/analytics';

const WebVitalsReporter = () => {
  useReportWebVitals((metric) => {
    if (process.env.NODE_ENV !== 'production') {
      return;
    }

    reportWebVital(metric);
  });

  return null;
};

export default WebVitalsReporter;
